<script lang="ts">
import { defineComponent } from 'vue';
import {mapState} from 'vuex';
import dayjs from 'dayjs';
import ScheduleSlot from '@/components/cards/ScheduleSlot.vue';
import {RootState} from '@/store';

export default defineComponent({
  name: 'ScheduledCards',
  components: {ScheduleSlot},
  data() {
    return {

    };
  },
  created: () => {},
  computed: {
    ...mapState({
      slots: (state: RootState) => state.scheduler.slots,
    }),
    groupByDate() {
      const slots = Object.assign([], this.slots);
      const initialObj = {};


      return slots.reduce((groups, slot) => {
        const dateObj = dayjs(slot.datetime, 'MM/DD/YYYY hh:mm A');
        const date = dateObj.format('YYYY-MM-DD');
        if (!groups[date]) {
          groups[date] = {
            dateFormatted: dateObj.format('dddd - MM/DD/YY'),
            slots: [],
          };
        }

        groups[date].slots.push(Object.assign({}, slot));
        return groups;
      }, initialObj);
    },
  },
  methods: {},
});
</script>

<template>
  <div>
    <h1 class="secondaryTitle my-3">Appointment Slots</h1>
    <div class="dateGroup my-4" v-for="groupedByDateSlot in groupByDate">
      <h1 class="dateTitle my-1">{{ groupedByDateSlot.dateFormatted }}</h1>

      <div v-for="slot in groupedByDateSlot.slots">
        <ScheduleSlot :slotByTime="slot" @slot-selected="$emit('slot-selected')"/>
      </div>
    </div>
  </div>
</template>

<style scoped>
.secondaryTitle {
  font-size: 18px;
  font-weight: 700;
  color: #111111;
}
.dateGroup {
  font-weight: 700;
  font-size: 18px;
}
.dateTitle {
  font-weight: 700;
  font-size: 16px;
}
</style>
